<template>
  <svg 
    :width="width" 
    :height="height" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    class="lapis-estrela-icon"
  >
    <path 
      d="M11.0452 20.827H7.50009C7.33178 20.827 7.17037 20.7601 7.05135 20.6411C6.93234 20.5221 6.86548 20.3607 6.86548 20.1924V16.6472C6.86556 16.4791 6.93231 16.318 7.0511 16.199L16.8337 6.41644C16.9527 6.29752 17.1141 6.23071 17.2823 6.23071C17.4505 6.23071 17.6119 6.29752 17.7309 6.41644L21.276 9.95918C21.3949 10.0782 21.4617 10.2395 21.4617 10.4078C21.4617 10.576 21.3949 10.7374 21.276 10.8564L11.4934 20.6413C11.3745 20.7601 11.2133 20.8269 11.0452 20.827Z" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M14.481 8.76929L18.9233 13.2116" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M16.7021 10.9905L9.08667 18.6059" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M11.2674 20.7864L6.90601 16.425" 
      :stroke="color" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    <path 
      d="M1.93118 3.30228C2.02692 2.90744 2.58846 2.90744 2.6842 3.30228L2.94764 4.38868C2.98182 4.52965 3.09189 4.63971 3.23285 4.6739L4.31926 4.93733C4.71409 5.03308 4.71409 5.59461 4.31926 5.69036L3.23285 5.95379C3.21523 5.95807 3.1981 5.96353 3.18153 5.97008C3.06556 6.01598 2.97755 6.11566 2.94764 6.23901L2.6842 7.32541C2.67822 7.35009 2.67042 7.37322 2.66102 7.39482C2.52009 7.71871 2.02094 7.69557 1.93118 7.32541L1.66774 6.23901C1.66561 6.2302 1.66317 6.22151 1.66046 6.21295C1.61968 6.08458 1.51469 5.98584 1.38253 5.95379L0.296124 5.69036C0.271447 5.68437 0.248312 5.67657 0.22672 5.66717C-0.0971657 5.52624 -0.0740311 5.02709 0.296124 4.93733L1.38253 4.6739C1.5235 4.63971 1.63356 4.52965 1.66774 4.38868L1.93118 3.30228Z" 
      :fill="color"
    />
    <path 
      d="M7.58729 8.31803C7.58729 8.82784 7.17401 9.24112 6.66421 9.24112C6.15441 9.24112 5.74113 8.82784 5.74113 8.31803C5.74113 7.80823 6.15441 7.39495 6.66421 7.39495C7.17401 7.39495 7.58729 7.80823 7.58729 8.31803Z" 
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'LapisEstrelaIcon',
  props: {
    color: {
      type: String,
      default: '#4B089F'
    },
    width: {
      type: [String, Number],
      default: 24
    },
    height: {
      type: [String, Number],
      default: 24
    }
  }
}
</script>

<style scoped>
.lapis-estrela-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
